import React, { useState } from "react";
import Login from "./MainLogin";
import PageProfile from "./Profile";

function MainLogin() {
  const [componente, setComponente] = useState(true);

  return (
    <>
      {componente && <Login setComponente={setComponente} componente={componente} />}
      {!componente && <PageProfile />}
    </>
  );
}

export default MainLogin;
